import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} ShippingRateLog
 * @property {string} id
 * @property {string} order_id
 * @property {string} order_number
 * @property {string} user_id
 * @property {string} user_name
 * @property {number} cart_item_count
 * @property {Array} shipping_rate_group_logs - Array of shipping rate groups with selected rates
 * @property {string} calculation_status
 * @property {string} created_at
 */

/**
 * @typedef {Object} ShippingRateLogsSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, ShippingRateLog>} data
 * @property {number} pageCount
 * @property {number} rowCount
 * @property {number} currentPage
 * @property {number} perPage
 */

export const SHIPPING_RATE_LOGS_ACTIONS = {
  SET_LOGS: 'SET_SHIPPING_RATE_LOGS',
  SET_LOG: 'SET_SHIPPING_RATE_LOG',
  SET_STATUS: 'SET_SHIPPING_RATE_LOGS_STATUS',
  SET_ERRORS: 'SET_SHIPPING_RATE_LOGS_ERRORS',
  CLEAR_ERRORS: 'CLEAR_SHIPPING_RATE_LOGS_ERRORS',
  SET_META: 'SET_SHIPPING_RATE_LOGS_META'
}

export const initialShippingRateLogsState = {
  status: 'idle',
  errors: [],
  data: {},
  pageCount: 0,
  rowCount: 0,
  currentPage: 1,
  perPage: 10
}

export const shippingRateLogsPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      order_id: PropTypes.string,
      order_number: PropTypes.string,
      user_id: PropTypes.string,
      user_name: PropTypes.string,
      cart_item_count: PropTypes.number,
      shipping_rate_group_logs: PropTypes.arrayOf(
        PropTypes.shape({
          selected_rate: PropTypes.shape({
            cost_in_cents: PropTypes.number,
            adjusted_cost_in_cents: PropTypes.number,
            tier_adjustment: PropTypes.object,
            rounding_adjustment: PropTypes.object
          })
        })
      ),
      calculation_status: PropTypes.string,
      created_at: PropTypes.string
    })
  )
}
